import { render, staticRenderFns } from "./ExportProductPpt.vue?vue&type=template&id=1a89752b&scoped=true"
import script from "./ExportProductPpt.vue?vue&type=script&lang=js"
export * from "./ExportProductPpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89752b",
  null
  
)

export default component.exports